import * as pdf from './pdf';
import * as auth from './auth';

export * from './instance';
export * from './constants';

export const api = {
  pdf,
  auth,
};
